<template>
    <div class="cloud-wrapper">
        <a-modal
            class="cloud-video"
            :visible="visible"
            :title="$t('program.view_cloud_video_list'/*云录制视频列表*/ )"
            :width="1100"
            :maskClosable="false"
            :confirm-loading="loading"
            @cancel="handleCancel"
            :footer="null">
            <!--    搜索条件    -->
            <div class="table-page-search-wrapper" ref="myHeader">
                <a-form layout="inline" class="hidden">
                    <a-row :gutter="[10, 10]">
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-form-item label="">
                                <a-input v-model="searchParams.hall_name" :placeholder="$t('program.meeting_hall'/*会场名称*/ )"></a-input>
                            </a-form-item>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-input v-model="searchParams.article_title" :placeholder="$t('program.program_name'/*日程名称*/ )"></a-input>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-select v-model="searchParams.status" :placeholder="$t('program.recording_task_status'/*录制任务状态*/ )">
                                <a-select-option value="">{{$t('program.all'/*全部*/ )}}</a-select-option>
                                <a-select-option value="1">{{$t('program.recording'/*录制中*/ )}}</a-select-option>
                                <a-select-option value="2">{{$t('program.upload_success'/*上传成功*/ )}}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :xl="6" :xxl="4" :lg="8" :xs="12" style="text-align: left">
                            <a-select v-model="searchParams.is_upload_video" :placeholder="$t('program.whether_upload_to_vod'/*是否上传到点播*/ )">
                                <a-select-option value="">{{$t('program.all'/*全部*/ )}}</a-select-option>
                                <a-select-option value="-1">{{$t('program.not_transcoded'/*未转码*/ )}}</a-select-option>
                                <a-select-option value="1">{{$t('program.transcoding'/*转码中*/ )}}</a-select-option>
                                <a-select-option value="2">{{$t('program.upload_success'/*上传成功*/ )}}</a-select-option>
                                <a-select-option value="-2">{{$t('program.upload_failed'/*上传失败*/ )}}</a-select-option>
                            </a-select>
                        </a-col>
                        <a-col :xl="6" :xxl="6" :lg="8" :xs="12" style="text-align: left">
                            <a-button type="primary" @click="handleSearch">{{$t('web.search'/*搜索*/ )}}</a-button>
                            <a-button class="ml5" type="primary" @click="handleSyncVideoEvent">{{$t('program.sync_cloud_video_to_vod'/*同步云录制视频到点播*/ )}}</a-button>
                        </a-col>
                    </a-row>
                </a-form>
            </div>
            <a-table ref="table" size="default" :columns="columns" :dataSource="dataList" :pagination="false" class="mt20">
                <template slot="status" slot-scope="text">
                    <a-badge v-if="text == 2" status="success" :text="$t('program.upload_success'/*上传成功*/ )" />
                    <a-badge v-if="text == 1" status="processing" :text="$t('program.recording'/*录制中*/ )"></a-badge>
                </template>
                <template slot="is_upload_video" slot-scope="text">
                    <a-badge v-if="text == 2" status="success" :text="$t('program.upload_success'/*上传成功*/ )" />
                    <a-badge v-if="text == -2" status="error" :text="$t('program.upload_failed'/*上传失败*/ )" />
                    <a-badge v-if="text == 1" status="processing" :text="$t('program.transcoding'/*转码中*/ )"></a-badge>
                    <a-badge v-if="text == -1" status="warning" :text="$t('program.not_transcoded'/*未转码*/ )"></a-badge>
                </template>
                <template slot="action" slot-scope="record">
                    <a :href="record.url" target="_blank">{{$t('program.download'/*下载*/ )}}</a>
                </template>
            </a-table>
            <div class="t-r mt30">
                <a-pagination
                    :show-total="total => $t('web.pagination_total', { value: total } /* 共{value}条 */)"
                    show-size-changer
                    v-model="pagination.page"
                    :page-size="pagination.limit"
                    :total="paginationTotal"
                    @change="handlePaginationChangeEvent"
                    @showSizeChange="handlePaginationChangeEvent"
                />
            </div>
        </a-modal>
    </div>
</template>
<script>
export default {
    name: 'subscribeModal',
    props: {
    },
    data() {
        return {
            visible: false,
            loading: false,
            columns: [
                {
                    title: 'ID',
                    dataIndex: 'id',
                    align: 'center',
                    fixed: 'left',
                    width: 80
                },
                {
                    title: this.$t('program.meeting_hall'/*会场名称*/),
                    dataIndex: 'meeting_hall',
                    align: 'center',
                    width: 120
                },
                {
                    title: this.$t('program.program_name'/*关联日程*/),
                    dataIndex: 'abstract_title',
                    align: 'center',
                    width: 130
                },
                {
                    title: this.$t('program.related_video'/*关联视频*/),
                    dataIndex: 'video_id',
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.recording_task_status'/*录制任务状态*/),
                    dataIndex: 'status',
                    scopedSlots: { customRender: 'status' },
                    align: 'center',
                    width: 100
                },

                {
                    title: this.$t('program.whether_upload_to_vod'/*是否上传到点播*/),
                    dataIndex: 'is_upload_video',
                    scopedSlots: { customRender: 'is_upload_video' },
                    align: 'center',
                    width: 100
                },
                {
                    title: this.$t('program.operation'/*操作*/),
                    dataIndex: 'action',
                    scopedSlots: { customRender: 'action' },
                    align: 'center',
                    width: 100
                }
            ],
            searchParams: {
            },
             // 分页
            pagination: {
                page: 1,
                limit: 10
            },
            dataList: [],
            paginationTotal: 0,
        };
    },
    created () {
    },
    methods: {
        /**
         * 打开云录制视频列表
        */
        showFun() {
            this.visible = true
            this.getDataList()
        },
        getDataList () {
            let data = {
                ...this.searchParams,
                ...this.pagination
            }
            this.loading = true
            this.$request.get({ url: 'getCloudVideoList', data }).then((res) => {
                const { count, list } = res.data
                this.dataList = list
                this.paginationTotal = Number(count)
            }).finally(() => {
                this.loading = false
            })
        },
        handleCancel() {
            this.visible = false;
        },
        handleSearch () {
            this.getDataList()
        },
        handleSyncVideoEvent () {
            this.$confirm({
                title: this.$t('web.tips'/*提示*/),
                content: this.$t('program.confirm_sync'/*是否确认同步?*/),
                okText: this.$t('web.ok'/*确定*/),
                cancelText: this.$t('web.cancel'/*取消*/),
                onOk: () => {
                    this.$request.post({ url: 'submitSyncVideo' }).then(res => {
                        this.$message.success(this.$t('program.sync_success'/*同步成功*/));
                    });
                }
            });
        },
        // 切换分页
        handlePaginationChangeEvent(page, limit) {
            this.pagination = {
                page,
                limit
            };
            this.getDataList();
        }
    },
};
</script>
<style lang="less" scoped>
::v-deep .ant-form-item {
    margin-bottom: 5px;
}
::v-deep .ant-modal-body {
    max-height: 72vh;
    overflow-y: auto;
}
/deep/ .table-page-search-wrapper .ant-form-inline .ant-form-item {
    margin-bottom: 0px;
}
</style>